import { Grid, Typography } from '@mui/material';
import { Field } from 'formik';
import React from 'react';
import HdFormikTextField from '../../../../../form/formik/components/text-field/HdFormikTextField';
import HdDocLink from '../../../../../docs/components/doc-link/HdDocLink';
import HdFormControl from '../../../../../form/components/form-control/HdFormControl';

const docLinkConfigureZendesk =
  '/activate/activate-targets/zendesk/#configuring-zendesk-as-a-target';
const docLinkApiToken = '/activate/activate-targets/zendesk/#generating-a-zendesk-api-token';

export default function Zendesk() {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='subDomain'
              label='Sub Domain'
              helperText='Specify your Zendesk URL (https://subdomain.zendesk.com)'
              required
              prefixText='https://'
              suffixText='.zendesk.com'
              component={HdFormikTextField}
            />
          </HdFormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='email'
              required
              label='Email'
              helperText={
                <Typography variant='caption'>
                  Specify an Admin account.{' '}
                  <HdDocLink
                    docLink={docLinkConfigureZendesk}
                    section='target_settings'
                    size='sm'
                    dataId='zendesk-email'
                  />
                </Typography>
              }
              component={HdFormikTextField}
            />
          </HdFormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='token'
              label='API Token'
              helperText={
                <Typography variant='caption'>
                  Specify your API Token.{' '}
                  <HdDocLink
                    docLink={docLinkApiToken}
                    section='target_settings'
                    size='sm'
                    dataId='zendesk-api-token'
                  />
                </Typography>
              }
              required
              component={HdFormikTextField}
            />
          </HdFormControl>
        </Grid>
      </Grid>
    </>
  );
}
